import React from "react";
import { SEO, MarkdownContent, DynamicScript } from "@bluefin/components";
import { Grid, Segment } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import {
  getComponentFiles,
  getComponentContentNodeContent,
} from "../utils/utils";

export default class CherryPaymentPlansPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
        />
        <Grid
          className={"custom-page-cherry-payment-plans custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row
            className={""}
            style={{ padding: 16 }}
            textAlign={"center"}
            verticalAlign={"middle"}
            columns={1}
          >
            <Grid.Column
              className={""}
              style={{ padding: 16 }}
              textAlign={"center"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "28db52bb-67c8-4a51-b7d3-1a62fa4c5b57",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className={""} style={{ padding: 16 }} columns={1}>
            <Grid.Column className={""} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__d8bfdd57-bd4f-42ca-81b6-a7c6ab72ff14"}
                >
                  <div>
                    <DynamicScript
                      type={"application/javascript"}
                      delay={200}
                      body={
                        "(function (w, d, s, o, f, js, fjs) {w[o] =w[o] ||function () {(w[o].q = w[o].q || []).push(arguments);};(js = d.createElement(s)), (fjs = d.getElementsByTagName(s)[0]);js.id = o;js.src = f;js.async = 1;fjs.parentNode.insertBefore(js, fjs);})(window, document, 'script', '_hw', ' https://files.withcherry.com/widgets/widget.js');_hw('init',{debug: false,variables: {slug: 'collectivebeautysalonspa',name: 'Collective Beauty LLC',},styles: {primaryColor: '#206c74',secondaryColor: '#206c7410',fontFamily: 'Open Sans',},},['all', 'hero', 'howitworks', 'testimony', 'faq', 'calculator']);"
                      }
                    />
                    <div id={"all"} />
                  </div>
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 24395 }) {
      title
      seoTitle
      description
      components {
        files {
          file
        }
        order
        fastId
        componentIdentifier
        contentNodes {
          content
        }
      }
    }
  }
`;
